import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppConfig {

	private config: any = null;
	private version: any = null;

	constructor(private http: HttpClient) { }

	public getConfig(key: any) {
		return this.config[key];
	}

	public getVersion(key: any) {
		return this.version[key];
	}

	public load() {

		return new Promise((resolve, reject) => {
			this.http.get<any>('./assets/env/env.json?_cache_buster=' + new Date().getTime()).subscribe(
				responseData => {
					this.config = responseData;

					this.http.get<any>('./assets/env/version.json?_cache_buster=' + new Date().getTime()).subscribe(
						responseData1 => {
							this.version = responseData1;
							resolve(true);
						},
						error => {
							console.error('Error reading version file');
							resolve(error);
							return Observable.throw(JSON.stringify(error) || 'Server error');
						}
					);
				},
				error => {
					console.error('Error reading configuration file');
					resolve(error);
					return Observable.throw(JSON.stringify(error) || 'Server error');
				}
			);
		});
	}
	/*
		public loadOld() {
			return new Promise((resolve, reject) => {
				this.http.get<any>('./assets/env/env.json').subscribe( 
					(envResponse) => {
						this.env = envResponse;
						let request: any = null;
	
						switch (envResponse.env) {
							case 'production': {
								request = this.http.get('./assets/env/env.' + envResponse.env + '.json');
							} break;
	
							case 'development': {
								request = this.http.get('./assets/env/env.' + envResponse.env + '.json');
							} break;
	
							case 'default': {
								console.error('Environment file is not set or invalid');
								resolve(true);
							} break;
						}
	
						if (request) {
							request
								.map( res => res.json() )
								.catch((error: any) => {
									console.error('Error reading ' + envResponse.env + ' configuration file');
									resolve(error);
									return Observable.throw(error.json().error || 'Server error');
								})
								.subscribe((responseData: any) => {
									this.config = responseData;
									resolve(true);
								});
						} else {
							console.error('Env config file "env.json" is not valid');
							resolve(true);
						}
					},
					error => {
	
						console.log('Configuration file "env.json" could not be read');
						resolve(true);
						return Observable.throw(error || 'Server error');
	
					});
	
			});
		}
		*/
}